import { connect } from 'react-redux'
import { selectLanguage } from 'store/locales'
import SampleTrial2Page from '../components/SampleTrial2Page'

const mapStateToProps = ({ strings }) => {
  return {
    strings,
  }
}

const mapDispatchToProps = {
  selectLanguage,
}

export default connect(mapStateToProps, mapDispatchToProps)(SampleTrial2Page)
